export default "__VITE_ASSET__DpyCKa_d__"